import apiHelper from "./apiHelper";
import { message } from "antd";

export const getBundles = async () => {
  const url = "/credits";
  const response: any = await apiHelper.get(url, {});
  return response;
};

export const createBundle = async (body: any) => {
  const url = "/credits";
  const response: any = await apiHelper.post(url, { ...body });
  if (response.data.statusCode === 201) {
    return { success: true };
  }
  message.error(response.data.message);
  throw new Error();
};

export const updateBundle = async (id: string, body: any) => {
  const url = `/credits/${id}`;
  const response: any = await apiHelper.patch(url, { ...body });
  if (response.data.statusCode === 200) {
    return { success: true };
  }
  message.error(response.data.message);
  throw new Error();
};

export const deleteBundle = async (id: string) => {
  const url = `/credits/${id}`;
  const response: any = await apiHelper.delete(url, {});
  if (response.data.statusCode === 200) {
    return { success: true };
  }
  message.error(response.data.message);
  throw new Error();
};
